/* MMW export: turns the current wall design into a clean, client-ready image
   (size, finish, add-ons, price + branding) that Max can download and send in chat.
   Reads the already-drawn #wcCanvas (same-origin, safe to export) + the spec DOM. */
(function(){
  function $(id){ return document.getElementById(id); }
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  ready(function(){
    var cv=$('wcCanvas'); if(!cv) return;
    var host=document.querySelector('.wc-cta'); if(!host || host.querySelector('.wc-share')) return;

    var bar=document.createElement('div'); bar.className='wc-share';
    bar.style.cssText='flex-basis:100%;display:flex;flex-direction:column;gap:8px;margin-top:6px';
    bar.innerHTML='<div style="display:flex;gap:12px;flex-wrap:wrap">'
      +'<button type="button" id="wcExport" class="lp-cta lp-cta--lg">&#128247; Save design image</button>'
      +'<button type="button" id="wcExportPhoto" class="lp-cta lp-cta--lg lp-cta--ghost">&#10022; Save realistic photo</button>'
      +'</div>'
      +'<small style="color:#6e6e73;font-size:.86rem">Downloads a clean image with your size, finish, add-ons and price &mdash; send it straight to your client on WhatsApp or email.</small>';
    host.appendChild(bar);
    $('wcExport').addEventListener('click', exportDesign);
    $('wcExportPhoto').addEventListener('click', exportPhoto);

    function t(id){ var e=$(id); return e?e.textContent.trim():''; }
    function dl(blob,name){ var a=document.createElement('a'); a.href=URL.createObjectURL(blob); a.download=name; document.body.appendChild(a); a.click(); setTimeout(function(){ URL.revokeObjectURL(a.href); a.remove(); },1500); }
    function fontS(px){ return px+'px -apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif'; }

    function exportDesign(){
      var btn=$('wcExport'), old=btn.innerHTML; btn.disabled=true; btn.innerHTML='Saving...';
      try{
        var s=2, W=1200*s, pad=56*s;
        var size=t('wcWv')+' '+t('wcWunit')+'  ×  '+t('wcHv')+' '+t('wcHunit');
        var finish=t('wcFname'), panels=t('wcPanels'), cover=t('wcCover'), total=t('wcPrice');
        var addons=[]; Array.prototype.forEach.call(document.querySelectorAll('#wcBreak span'), function(sp){ var b=sp.querySelector('b'); if(!b) return; var label=sp.textContent.replace(b.textContent,'').trim(); addons.push([label,b.textContent.trim()]); });

        var cw=cv.clientWidth||700, chh=cv.clientHeight||Math.round(cw*0.64);
        var imgW=W-pad*2, imgH=Math.round(imgW*chh/cw);
        var headH=150*s, rowH=56*s, specsH=(addons.length+3)*rowH+24*s, totalH=76*s, footH=120*s;
        var H=pad+headH+imgH+40*s+specsH+totalH+footH;

        var ex=document.createElement('canvas'); ex.width=W; ex.height=H; var g=ex.getContext('2d');
        g.fillStyle='#ffffff'; g.fillRect(0,0,W,H);
        g.textBaseline='top';
        g.fillStyle='#1d1d1f'; g.font='700 '+fontS(42*s); g.fillText('MAX MEDIA WALLS',pad,pad);
        g.fillStyle='#6e6e73'; g.font='500 '+fontS(24*s); g.fillText('Your custom media wall design',pad,pad+54*s);

        var iy=pad+headH;
        g.fillStyle='#f0f0f3'; g.fillRect(pad,iy,imgW,imgH);
        g.drawImage(cv,pad,iy,imgW,imgH);

        var y=iy+imgH+40*s;
        g.strokeStyle='rgba(0,0,0,.10)'; g.lineWidth=s;
        function row(label,val,big){
          g.textBaseline='alphabetic';
          g.fillStyle=big?'#0071e3':'#6e6e73'; g.textAlign='left'; g.font=(big?'600 ':'500 ')+fontS((big?28:24)*s); g.fillText(label,pad,y+ (big?34:30)*s);
          g.fillStyle=big?'#0071e3':'#1d1d1f'; g.textAlign='right'; g.font='700 '+fontS((big?36:26)*s); g.fillText(val,W-pad,y+(big?34:30)*s);
          g.beginPath(); g.moveTo(pad,y+(big?54:rowH-14*s)); g.lineTo(W-pad,y+(big?54:rowH-14*s)); g.stroke();
          y+= big?totalH:rowH;
        }
        row('Wall size',size);
        row('Finish',finish);
        row('Panels',panels+'   ('+cover+')');
        addons.forEach(function(a){ row(a[0],a[1]); });
        row('Estimated total',total,true);

        g.fillStyle='#1d1d1f'; g.fillRect(0,H-footH,W,footH);
        g.textAlign='left'; g.textBaseline='middle';
        g.fillStyle='#ffffff'; g.font='600 '+fontS(28*s); g.fillText('maxmediawalls.com',pad,H-footH/2-16*s);
        g.fillStyle='rgba(255,255,255,.78)'; g.font='500 '+fontS(22*s); g.fillText('Text Max at 424-345-7142 for your exact quote',pad,H-footH/2+22*s);

        ex.toBlob(function(b){ btn.disabled=false; btn.innerHTML=old; if(!b){ alert('Could not export the image, please try again.'); return; } dl(b,'max-media-wall-design.jpg'); },'image/jpeg',0.94);
      }catch(e){ btn.disabled=false; btn.innerHTML=old; alert('Export failed: '+e.message); }
    }

    function exportPhoto(){
      var ri=$('wcRenderImg');
      if(!ri || ri.hidden || !ri.getAttribute('src')){ alert('First tap "✦ Realistic render" to generate the photo, then save it here.'); return; }
      var btn=$('wcExportPhoto'), old=btn.innerHTML; btn.disabled=true; btn.innerHTML='Saving...';
      var src=ri.getAttribute('src');
      var im=new Image(); im.crossOrigin='anonymous';
      im.onload=function(){
        try{
          var s=2, W=1024*s, iw=im.naturalWidth||1024, ih=im.naturalHeight||768;
          var imgW=W, imgH=Math.round(imgW*ih/iw), footH=120*s, H=imgH+footH;
          var c=document.createElement('canvas'); c.width=W; c.height=H; var g=c.getContext('2d');
          g.fillStyle='#000'; g.fillRect(0,0,W,H);
          g.drawImage(im,0,0,imgW,imgH);
          g.fillStyle='#1d1d1f'; g.fillRect(0,imgH,W,footH);
          g.textBaseline='middle'; g.textAlign='left';
          g.fillStyle='#fff'; g.font='600 '+fontS(28*s); g.fillText('MAX MEDIA WALLS',40*s,imgH+footH/2-16*s);
          g.fillStyle='rgba(255,255,255,.78)'; g.font='500 '+fontS(22*s); g.fillText('maxmediawalls.com  ·  Text 424-345-7142 for a quote',40*s,imgH+footH/2+22*s);
          c.toBlob(function(b){ btn.disabled=false; btn.innerHTML=old; if(!b){ window.open(src,'_blank'); return; } dl(b,'max-media-wall-photo.jpg'); },'image/jpeg',0.95);
        }catch(e){ btn.disabled=false; btn.innerHTML=old; window.open(src,'_blank'); }
      };
      im.onerror=function(){ btn.disabled=false; btn.innerHTML=old; window.open(src,'_blank'); };
      im.src=src;
    }
  });
})();
